var React = require('react');

function Icon3Inline (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"fill":"#ef7800","d":"M35.185 32.052a1.55 1.55 0 0 1-1.557 1.542h-2.725a1.55 1.55 0 0 1-1.558-1.542V17.57a1.55 1.55 0 0 1 1.558-1.541h2.725c.86 0 1.557.69 1.557 1.541zm-9.856 0a1.55 1.55 0 0 1-1.558 1.542h-2.726a1.55 1.55 0 0 1-1.557-1.542v-9.564a1.55 1.55 0 0 1 1.557-1.542h2.726c.86 0 1.558.69 1.558 1.542zm-9.147 0a1.55 1.55 0 0 1-1.558 1.542h-2.725a1.55 1.55 0 0 1-1.558-1.542V14.056a1.55 1.55 0 0 1 1.558-1.542h2.725c.86 0 1.558.69 1.558 1.542zM22.763.468C10.29.468.177 10.58.177 23.054c0 12.474 10.112 22.586 22.586 22.586 12.474 0 22.586-10.112 22.586-22.586C45.35 10.58 35.237.468 22.763.468z"}))));
}

Icon3Inline.defaultProps = {"width":"46","height":"46","viewBox":"0 0 46 46"};

module.exports = Icon3Inline;

Icon3Inline.default = Icon3Inline;
